import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from '@/views/Login.vue'
import History from '@/views/History.vue'
import Homepage from "@/views/Homepage.vue";
import ChangePassword from '@/views/ChangePassword.vue'
import OpenGame from "@/views/OpenGame.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'homepage',
    component: Homepage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/lobby/:vendorId/games/:gameId',
    name: 'openGame',
    component: OpenGame,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/history',
    name: 'history',
    component: History,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/password',
    name: 'changePassword',
    component: ChangePassword,
    meta: {
      requiresAuth: true,
    },
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router

